import { Window } from './Window';
import { getNumber } from './WindowHelpers';

export class UpperCircularWindow extends Window {
  constructor(renderer, parent, def) {
    super(renderer, parent, def);
  }

  _parseGeometryData(geometryData) {
    return {
      P1: getNumber(geometryData, 'P1', 'Length') / 1000,
    };
  }

  _create2DVertices(width, height, adjust, geometryData) {
    return create2DVertices(width, height, adjust, geometryData.P1);
  }

  _transformDimensionsToRect(dimensions, width, height, geometryData) {
    return transformDimensionsToRect(
      dimensions,
      width,
      height,
      geometryData.P1
    );
  }

  _getGeometryChangeOnShrink(geometryData, dimensions, width, height) {
    return {
      P1: dimensions.UNP - dimensions.OVP,
    };
  }
}

function getCircleWidth(width, height, reducedHeight) {
  if (height > reducedHeight) {
    return width;
  }

  const totalHeight = height + reducedHeight;
  const y = (height / totalHeight) * 2 - 1;
  const x = Math.sqrt(1 - y * y);
  return width / x;
}

export function transformDimensionsToRect(
  dimensions,
  width,
  height,
  reducedHeight
) {
  const circleWidth = getCircleWidth(width, height, reducedHeight);
  const circleHeight = height + reducedHeight;
  const outerY = (reducedHeight / circleHeight) * 2 - 1;
  const outerX = Math.sqrt(1 - outerY * outerY);
  const outerWidth = (height > reducedHeight ? 1 : outerX) * circleWidth;

  const innerCircleWidth = circleWidth - dimensions.OVP * 2;
  const innerCircleHeight = circleHeight - dimensions.OVP * 2;
  const innerReducedHeight = reducedHeight + dimensions.UNP - dimensions.OVP;
  const innerHeight = innerCircleHeight - innerReducedHeight;
  const innerY = (innerReducedHeight / innerCircleHeight) * 2 - 1;
  const innerX = Math.sqrt(1 - innerY * innerY);
  const innerWidth =
    (innerHeight > innerReducedHeight ? 1 : innerX) * innerCircleWidth;

  const dx = (outerWidth - innerWidth) / 2;

  return {
    left: dx,
    right: dx,
    top: dimensions.OVP,
    bottom: dimensions.UNP,
  };
}

const segmentCount = 256;
export function create2DVertices(width, height, adjust, reducedHeight) {
  const v = [];
  const circleWidth =
    getCircleWidth(width, height, reducedHeight) + adjust.OVP * 2;
  const circleHeight = height + reducedHeight + adjust.OVP * 2;
  const angleStep = (-Math.PI * 2) / segmentCount;
  const startY =
    ((reducedHeight - adjust.UNP + adjust.OVP) / circleHeight) * 2 - 1;
  const startX = -Math.sqrt(1 - startY * startY);
  let startAngle = Math.atan2(startY, startX);
  if (startAngle < 0) startAngle += Math.PI * 2;
  const endAngle = Math.atan2(startY, -startX);
  const dy = -reducedHeight / 2;

  let currAngle = Math.PI * 1.5;
  for (let i = 0; i < segmentCount; i++) {
    const angle = Math.min(startAngle, Math.max(endAngle, currAngle));
    const x = Math.cos(angle) / 2;
    const y = Math.sin(angle) / 2;
    v.push(circleWidth * x, circleHeight * y + dy);
    currAngle += angleStep;
  }

  return v;
}
